import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-252">
      <div className="max-w-3xl mx-auto text-center" data-id="element-253">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-254">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <p className="text-gray-300 text-lg sm:text-xl mb-4 leading-relaxed" data-id="element-255">
          Sos docente de Italiano. Amás el idioma. Pero nadie te dijo que ibas a
          pasar los domingos buscando actividades que no encajan, armando
          evaluaciones a la noche y llegando al lunes con material que "más o
          menos sirve".
        </p>

        <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-10" data-id="element-256">
          No es falta de vocación. Es falta de un sistema.
        </p>

        <div className="space-y-4 text-left mb-12" data-id="element-257">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-258">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-259">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-260">
              Domingo buscando actividades que nunca quedan bien para el alumno
              argentino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-261">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-262">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-263">
              Planificaciones para dirección armadas la noche anterior, a las
              corridas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-264">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-265">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-266">
              Siempre las mismas verifiche porque no tenés un banco de
              evaluaciones serio
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-267">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-268">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-269">
              El Congiuntivo, el Periodo Ipotetico, los Pronomi Combinati — sin
              sistema visual
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-270">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-271">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-272">
              Grupos con distintos niveles juntos sin material diferenciado —
              explicás al promedio y perdés a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-273">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-274">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-275">
              Fin de semana agotado, domingo volvés a empezar el mismo ciclo
            </p>
          </div>
        </div>

        <p className="text-[#00C853] text-2xl sm:text-3xl font-black mb-8 italic" data-id="element-276">
          ¿Y si este fuera el último domingo que pasás así?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00C853] to-transparent w-full" data-id="element-277" />
      </div>
    </section>;
}